module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


	var pCurrent = parseInt(current);
	var pTotal = parseInt(total);

	var startPage = localize({
		'ru': 'В начало',
		'en': 'To start'
	})

	var nextPage = localize({
		'ru': 'дальше',
		'en': 'forwards'
	})
;
__p += '\n	<ul class="pagination__list ul--clear">\n		';
 if (pCurrent > 1) { ;
__p += '\n			<li class="pagination__item pagination__item--prev"><a class="pagination__link js-component-filter" href="#">' +
((__t = (startPage)) == null ? '' : __t) +
'</a></li>\n		';
 } ;
__p += '\n\n		';
 if (pCurrent == 1 || pCurrent == 2) { ;
__p += '\n			';
 var thisTotal = (pTotal > 5) ? 5 : pTotal; ;
__p += '\n			';
 for (var i = 1; i <= thisTotal; i++) { ;
__p += '\n				<li class="pagination__item"><a class="pagination__link js-component-filter' +
((__t = ((i == pCurrent) ? ' pagination__link--active' : '' )) == null ? '' : __t) +
'" data-filter-value="' +
((__t = (i)) == null ? '' : __t) +
'" href="#">' +
((__t = (i)) == null ? '' : __t) +
'</a></li>\n			';
 } ;
__p += '\n		';
 } else if (pCurrent + 2 > pTotal) { ;
__p += '\n			';
 var thisStart = (pTotal <= 5) ? 1 : pTotal-4; ;
__p += '\n			';
 for (var i = thisStart; i <= pTotal; i++) { ;
__p += '\n				<li class="pagination__item"><a class="pagination__link js-component-filter' +
((__t = ((i == pCurrent) ? ' pagination__link--active' : '' )) == null ? '' : __t) +
'" data-filter-value="' +
((__t = (i)) == null ? '' : __t) +
'" href="#">' +
((__t = (i)) == null ? '' : __t) +
'</a></li>\n			';
 } ;
__p += '\n		';
 } else { ;
__p += '\n			';
 for (var i = pCurrent-2; i <= pCurrent+2; i++) { ;
__p += '\n				<li class="pagination__item"><a class="pagination__link js-component-filter' +
((__t = ((i == pCurrent) ? ' pagination__link--active' : '' )) == null ? '' : __t) +
'" data-filter-value="' +
((__t = (i)) == null ? '' : __t) +
'" href="#">' +
((__t = (i)) == null ? '' : __t) +
'</a></li>\n			';
 } ;
__p += '\n		';
 } ;
__p += '\n		';
 if (pCurrent < pTotal) { ;
__p += '\n		<li class="pagination__item pagination__item--next"><a class="pagination__link js-component-filter" href="#">' +
((__t = (nextPage)) == null ? '' : __t) +
'</a></li>\n		';
 } ;
__p += '\n	</ul>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./frontend/components/pagination/pagination.ejs
// module id = 51
// module chunks = 0